import { getFetch } from '../fetch';
import { apiConfig } from '../config';
import { Subscription } from '../../../typings';

interface AvailableSubscriptionsRequestData {
    course_id: number;
    grades: number[];
    subjects: string[];
}

export interface AvailableSubscriptionsResponseData {
    results: Subscription[];
}

export function getAvailableSubscriptions(request: AvailableSubscriptionsRequestData)
    : Promise<AvailableSubscriptionsResponseData> {

    const { apiGetAvailableSubscriptions } = apiConfig.getStaticUrls();
    return getFetch(apiGetAvailableSubscriptions, request);
}
